import { posthogCaptureWithUserContext } from "./general";

/**
 * Captures the event the user turns on the anonymise mode from
 * the settings page.
 */
export function posthogEventAnonymiseModeTurnedOn() {
  posthogCaptureWithUserContext("anonymise_mode_turned_on");
}

/**
 * Captures the event the user clicks on a user result after using
 * the top search bar.
 */
export function posthogEventSearchUserClicked() {
  posthogCaptureWithUserContext("search_user_clicked");
}

/**
 * Captures the event the user chooses the move class option from
 * the user search result modal.
 */
export function posthogEventSearchUserMoveClassChosen() {
  posthogCaptureWithUserContext("search_user_move_class_chosen");
}

/**
 * Captures the event the user chooses the edit details option from
 * the user search result modal.
 */
export function posthogEventSearchUserEditDetailsChosen() {
  posthogCaptureWithUserContext("search_user_edit_details_chosen");
}

/**
 * Captures the event the user submits the edit details form on the
 * user search result modal.
 */
export function posthogEventSearchUserEditDetailsSubmitted() {
  posthogCaptureWithUserContext("search_user_edit_details_submitted");
}

/**
 * Captures the event the user force activates a selection of user
 * accounts for a specific class
 *
 * @param {Object} properties
 * @param {string} properties.triggerId The ID of the trigger.
 * @param {string} properties.classId The ID of the class.
 * @param {string} properties.studentsRequiredToUseSSO Whether the school requires SSO for students.
 * @param {number} properties.userCount The number of users being force activated.
 * @param {number} properties.userCountWithEmails The number of users being force activated and have emails addresses.
 */
export function posthogEventClassesForceActivationUsed({
  triggerId,
  classId,
  studentsRequiredToUseSSO,
  userCount,
  userCountWithEmails,
}) {
  posthogCaptureWithUserContext("classes_force_activation_used", {
    trigger_id: triggerId,
    class_id: classId,
    students_required_to_use_sso: studentsRequiredToUseSSO,
    user_count: userCount,
    user_count_with_emails: userCountWithEmails,
  });
}

/**
 * Captures the event the user changes the password for a selection
 * of user accounts for a specific class.
 *
 * @param {Object} properties
 * @param {string} properties.triggerId The ID of the trigger.
 * @param {string} properties.classId The ID of the class.
 * @param {string} properties.studentsRequiredToUseSSO Whether the school requires SSO for students.
 * @param {number} properties.userCount The number of users whose password is being changed.
 * @param {number} properties.userCountWithEmails The number of users whose password is being changed and have emails addresses.
 */
export function posthogEventClassesChangePasswordUsed({
  triggerId,
  classId,
  studentsRequiredToUseSSO,
  userCount,
  userCountWithEmails,
}) {
  posthogCaptureWithUserContext("classes_change_password_used", {
    trigger_id: triggerId,
    class_id: classId,
    students_required_to_use_sso: studentsRequiredToUseSSO,
    user_count: userCount,
    user_count_with_emails: userCountWithEmails,
  });
}
